import React from "react";

import "../../styles/components/button.scss";

import { cssModifiers } from "../../utils/sass.js";

/**
 * @type {(props: {
 *  children: React.ReactNode,
 *  outlined: boolean,
 *  onClick: Function,
 *  disabled: boolean,
 *  className?: string,
 *  color?: 'main'|'danger'|'light'
 * }) => React.ReactNode}
 */
export default function Button(props) {
  const { children, onClick, disabled, className, color, style } = props;
  const classes = cssModifiers(props);

  return (
    <React.Fragment>
      <button
        className={`${classes("button", "outlined", "disabled")} button--${
          color || "main"
        } ${className || ""} submit-button`}
        onClick={onClick}
        disabled={disabled}
        style={style}
      >
        {children}
      </button>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/rifa/components/layout/button.jsx